module.exports = __webpack_public_path__ + "static/proyecto-tns-369e784adc967c207428e571ebe5a3fb.png";